import { Component, inject, input } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatHint, MatLabel } from '@angular/material/input';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { TooltipDirective, TooltipPosition } from '../../../../core/directives/tooltip';
import { AppTranslateService } from '../../../../core/services/app.translate.service';
import { IErrorMessage } from '../../../../core/types/general';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-radio-group',
  imports: [
    MatRadioGroup,
    MatRadioButton,
    MatLabel,
    TranslatePipe,
    NgClass,
    MatIcon,
    TooltipDirective,
    ReactiveFormsModule,
    MatError,
    MatHint,
  ],
  templateUrl: './radio-group.html',
  styleUrl: './radio-group.scss',
})
export class RadioGroup {
  protected readonly Validators = Validators;
  protected readonly TooltipPosition = TooltipPosition;

  protected readonly appTranslate = inject(AppTranslateService);

  className = input.required<string>();
  radioGroupControl = input.required<FormControl>();
  label = input<string>();
  options = input.required<{ value: string | number; label: string }[]>();
  errorMessages = input<IErrorMessage[]>([]);
  hintMessage = input<string | null>();
  readonly = input<boolean>(false);
  hideRequiredMarker = input<boolean>(false);
  infoTooltip = input<string | null>('');

  getFirstError() {
    return this.errorMessages().find((e) => this.radioGroupControl().hasError(e.errorName) && this.radioGroupControl().touched);
  }
}
